import React from 'react';
import dialogLoader from '../utilities/dialogLoader';
export default class ModalDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dialog: null,
      callback: {},
    };

    dialogLoader.setDelegate((component, state) => {
      this.setState({
        dialog: component,
        state,
      });
    });
  }

  /**
   * ダイアログ表示
   */
  dialog() {
    if (this.state.dialog) {
      const _dialog = this.state.dialog;
      return <_dialog dialog={this.state.state} />;
    }
    return <div />;
  }

  render() {
    const dialogshow = () => {
      return this.state.dialog ? 'modal show' : 'modal';
    };
    return (
      <div className={dialogshow()} onClick={() => {}}>
        {this.dialog()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modalDialog.js